module.exports = __webpack_public_path__ + "img/title_emergencyContact.b736d737.svg";